import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter, Link } from 'react-router-dom';
import idx from 'idx';
import { toArray } from 'lodash';
import { reduxForm } from 'redux-form';

import {
	colors,
	sidebarWidth,
	sidebarBreakpoint,
	preHeaderHeight,
} from '../variables';
import { logout as logoutAction } from '../../actions/auth';
import AdminNotifications from '../AdminNotifications/AdminNotifications';
import { toggleSidebar } from '../../actions/sidebar';
import SearchForm from '../Search/SearchForm';
import { navigateToSearch } from '../../actions/search';
import Hamburger from './Hamburger';
import ProfileSection from './ProfileSection';
import logotype from '../../images/logo_white.svg';

const PreHeader = styled.div`
	background: ${colors.blue.brommaDarkest};
	height: ${preHeaderHeight + 'px'};
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 0 10px;
	z-index: 101;

	@media print {
		display: none;
	}

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		display: none;
	}
`;

const MainHeader = styled.div`
	background: #fff;
	height: 72px;
	border-bottom: 1px solid ${colors.grey.normal};
	position: fixed;
	top: ${preHeaderHeight + 'px'};
	z-index: 100;
	right: 0;
	width: calc(100% - ${sidebarWidth + 'px'});
	display: flex;
	align-items: center;

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		width: 100%;
		background: ${colors.blue.brommaDarkest};
		border-color: ${colors.blue.brommaDarkest};
		justify-content: space-between;
		top: 0;
	}

	@media print {
		display: none;
	}
`;

const LogoLink = styled(Link)`
	display: block;
	padding: 20px;
	margin-left: auto;
	margin-right: auto;

	@media (min-width: ${sidebarBreakpoint + 1 + 'px'}) {
		display: none;
	}

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}
`;

const Logo = styled.img`
	margin-left: auto;
	margin-right: auto;
	display: block;
	height: 30px;
	max-width: 200px;
`;

const SearchContainer = styled.div`
	flex: 0 0 auto;
	display: flex;
	margin-left: auto;
	margin-right: 20px;

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		display: none;
	}
`;

const MobileProfile = styled.div`
	display: none;
	margin-right: 10px;

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		display: block;
	}
`;

class TopBar extends React.Component {
	handleSearch = () => {
		this.props.navigateToSearch(this.props.history);
	};

	render() {
		if (!this.props.auth.isAuthenticated || !this.props.user) return null;

		return (
			<React.Fragment>
				<PreHeader>
					<ProfileSection user={this.props.user} logout={this.props.logout} />
				</PreHeader>

				<MainHeader>
					<Hamburger
						onClick={() => this.props.toggleSidebar()}
						open={this.props.sidebar.visible}
					/>

					<LogoLink to="/">
						<Logo src={logotype} alt="Bromma Backyard" />
					</LogoLink>

					<AdminNotifications
						notifications={toArray(this.props.adminNotifications)}
						timezoneOffset={this.props.auth.timezoneOffset}
					/>

					<SearchContainer>
						<SearchForm
							sendSearch={this.props.handleSubmit(this.handleSearch)}
							search={this.props.search}
							topBar
						/>
					</SearchContainer>

					<MobileProfile>
						<ProfileSection user={this.props.user} logout={this.props.logout} />
					</MobileProfile>
				</MainHeader>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	entities: state.entities,
	auth: state.auth,
	search: state.search,
	sidebar: state.sidebar,
	adminNotifications: state.entities.adminNotifications,
	user: idx(state, _ => _.entities.users[state.auth.user]),
	initialValues: {
		type: 'serial_number',
	},
});

const mapDispatchToProps = dispatch => ({
	logout: () => dispatch(logoutAction()),
	toggleSidebar: () => dispatch(toggleSidebar()),
	navigateToSearch: (...args) => dispatch(navigateToSearch(...args)),
});

const formWrappedTopBar = reduxForm({
	form: 'topSearchForm',
})(TopBar);

const routerWrappedTopBar = withRouter(formWrappedTopBar);

export default connect(mapStateToProps, mapDispatchToProps)(
	routerWrappedTopBar
);



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.js